/*
 * Lazy-loads colourway swatch background images.
 *
 * Swatches paint via the CSS custom property --swatch-background (consumed by
 * .color-swatch and .hp-swatch-circle). Because those are CSS backgrounds,
 * loading="lazy" cannot defer them — so the swatch URL is rendered into a
 * data-swatch-bg attribute instead of an inline style, and this script sets the
 * property (triggering the fetch) only when the swatch nears the viewport.
 *
 * On product pages with 40+ colourways this defers ~37 off-screen image
 * requests on initial load (all of them, on mobile, where the picker is below
 * the fold). Source snippets: colorway-swatch-sp.liquid, colorway-swatch-v.liquid.
 *
 * init() is idempotent (hydrated swatches drop their data-swatch-bg, so re-runs
 * only pick up fresh, un-hydrated nodes) and re-runs after a Section Rendering
 * re-render — otherwise toggling any setting in the theme editor (or a variant
 * change) replaces the swatch DOM with un-hydrated nodes and the circles render
 * empty, which looks like the swatches disappearing.
 */
(function () {
  function hydrate(el) {
    var url = el.getAttribute('data-swatch-bg');
    if (!url) return;
    el.style.setProperty('--swatch-background', "url('" + url + "')");
    el.removeAttribute('data-swatch-bg');
  }

  function init() {
    var els = document.querySelectorAll('[data-swatch-bg]');
    if (!els.length) return;

    // No IntersectionObserver (very old browsers): just hydrate everything.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) hydrate(els[i]);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          hydrate(entries[i].target);
          obs.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '300px 0px' }); // preload just before they scroll into view

    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  // Run on this execution — covers initial load and, if the section (and this
  // script) is re-rendered, the fresh nodes too.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-hydrate after a Section Rendering re-render. Bind once so repeated section
  // reloads don't stack listeners.
  if (!window.__hpSwatchLazyBound) {
    window.__hpSwatchLazyBound = true;
    document.addEventListener('shopify:section:load', init);
  }
})();
